const SandwichData = [
  {
    productname: "VEG SANDWICH",
    productdescription:
      "Grilled bread with freshly chopped vegetables and cashew cheese",
  },
  {
    productname: "MUSH CORN SANDWICH",
    productdescription:
      "Combination of mushroom and corn, wedged between the layers of bread",
  },
];
export default SandwichData;
